import { render, staticRenderFns } from "./header-messages.vue?vue&type=template&id=a53556aa&"
import script from "./header-messages.vue?vue&type=script&lang=js&"
export * from "./header-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports